import React from 'react';
import './App.css';
import Home from './components/Home';


function App() {
  return (
    <div>
      {/* <div className="Header">
        High Altitude Analytics
      </div> */}
      <Home />
    </div>
  );
}

export default App;
